/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActivateAccount200ResponseSchema } from '../models/ActivateAccount200ResponseSchema';
import type { ActivateAccountRequestSchema } from '../models/ActivateAccountRequestSchema';
import type { DeleteProfile200ResponseSchema } from '../models/DeleteProfile200ResponseSchema';
import type { DeleteProfileRequestSchema } from '../models/DeleteProfileRequestSchema';
import type { GetUser200ResponseSchema } from '../models/GetUser200ResponseSchema';
import type { GetUserRequestSchema } from '../models/GetUserRequestSchema';
import type { ListUsers200ResponseSchema } from '../models/ListUsers200ResponseSchema';
import type { ListUsersRequestSchema } from '../models/ListUsersRequestSchema';
import type { Login200ResponseSchema } from '../models/Login200ResponseSchema';
import type { LoginRequestSchema } from '../models/LoginRequestSchema';
import type { LoginWithGoogle200ResponseSchema } from '../models/LoginWithGoogle200ResponseSchema';
import type { LoginWithGoogleRequestSchema } from '../models/LoginWithGoogleRequestSchema';
import type { OkResponseSchema } from '../models/OkResponseSchema';
import type { RefreshToken200ResponseSchema } from '../models/RefreshToken200ResponseSchema';
import type { RefreshTokenRequestSchema } from '../models/RefreshTokenRequestSchema';
import type { RequireResetPassword200ResponseSchema } from '../models/RequireResetPassword200ResponseSchema';
import type { RequireResetPasswordRequestSchema } from '../models/RequireResetPasswordRequestSchema';
import type { ResendConfirmationEmailRequestSchema } from '../models/ResendConfirmationEmailRequestSchema';
import type { ResetPasswordRequestSchema } from '../models/ResetPasswordRequestSchema';
import type { Signup200ResponseSchema } from '../models/Signup200ResponseSchema';
import type { SignupRequestSchema } from '../models/SignupRequestSchema';
import type { SignupWithGoogle200ResponseSchema } from '../models/SignupWithGoogle200ResponseSchema';
import type { SignupWithGoogleRequestSchema } from '../models/SignupWithGoogleRequestSchema';
import type { UpdateProfile200ResponseSchema } from '../models/UpdateProfile200ResponseSchema';
import type { UpdateProfileRequestSchema } from '../models/UpdateProfileRequestSchema';
import type { UpdateUserAsAdmin200ResponseSchema } from '../models/UpdateUserAsAdmin200ResponseSchema';
import type { UpdateUserAsAdminRequestSchema } from '../models/UpdateUserAsAdminRequestSchema';
import type { UpdateUserPasswordRequestSchema } from '../models/UpdateUserPasswordRequestSchema';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UsersService {

    /**
     * resetPassword
     * reset password
     * @param requestBody
     * @returns OkResponseSchema ResetPassword200Response
     * @throws ApiError
     */
    public static resetPassword(
        requestBody?: ResetPasswordRequestSchema,
    ): CancelablePromise<OkResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/resetPassword',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `ResetPassword400Response`,
            },
        });
    }

    /**
     * activateAccount
     * activate Account
     * @param requestBody
     * @returns ActivateAccount200ResponseSchema ActivateAccount200Response
     * @throws ApiError
     */
    public static activateAccount(
        requestBody?: ActivateAccountRequestSchema,
    ): CancelablePromise<ActivateAccount200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/activateAccount',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `ActivateAccount400Response`,
            },
        });
    }

    /**
     * deleteProfile
     * delete profile
     * @param requestBody
     * @returns DeleteProfile200ResponseSchema DeleteProfile200Response
     * @throws ApiError
     */
    public static deleteProfile(
        requestBody?: DeleteProfileRequestSchema,
    ): CancelablePromise<DeleteProfile200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/deleteProfile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `DeleteProfile400Response`,
            },
        });
    }

    /**
     * getUser
     * get profile settings and details
     * @param requestBody
     * @returns GetUser200ResponseSchema GetUser200Response
     * @throws ApiError
     */
    public static getUser(
        requestBody?: GetUserRequestSchema,
    ): CancelablePromise<GetUser200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/getUser',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `GetUser400Response`,
                404: `GetUser404Response`,
            },
        });
    }

    /**
     * login
     * log in
     * @param requestBody
     * @returns Login200ResponseSchema Login200Response
     * @throws ApiError
     */
    public static login(
        requestBody?: LoginRequestSchema,
    ): CancelablePromise<Login200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Login400Response`,
            },
        });
    }

    /**
     * requireResetPassword
     * require reset password
     * @param requestBody
     * @returns RequireResetPassword200ResponseSchema RequireResetPassword200Response
     * @throws ApiError
     */
    public static requireResetPassword(
        requestBody?: RequireResetPasswordRequestSchema,
    ): CancelablePromise<RequireResetPassword200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/requireResetPassword',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `RequireResetPassword400Response`,
            },
        });
    }

    /**
     * updateProfile
     * update profile
     * @param requestBody
     * @returns UpdateProfile200ResponseSchema UpdateProfile200Response
     * @throws ApiError
     */
    public static updateProfile(
        requestBody?: UpdateProfileRequestSchema,
    ): CancelablePromise<UpdateProfile200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/updateProfile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `UpdateProfile400Response`,
                403: `UpdateProfile403Response`,
                404: `UpdateProfile404Response`,
            },
        });
    }

    /**
     * signup
     * Sign up
     * @param requestBody
     * @returns Signup200ResponseSchema Signup200Response
     * @throws ApiError
     */
    public static signup(
        requestBody?: SignupRequestSchema,
    ): CancelablePromise<Signup200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/signup',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Signup400Response`,
            },
        });
    }

    /**
     * loginWithGoogle
     * login with google
     * @param requestBody
     * @returns LoginWithGoogle200ResponseSchema LoginWithGoogle200Response
     * @throws ApiError
     */
    public static loginWithGoogle(
        requestBody?: LoginWithGoogleRequestSchema,
    ): CancelablePromise<LoginWithGoogle200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/loginWithGoogle',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `LoginWithGoogle400Response`,
            },
        });
    }

    /**
     * signupWithGoogle
     * Sign up with google provider
     * @param requestBody
     * @returns SignupWithGoogle200ResponseSchema SignupWithGoogle200Response
     * @throws ApiError
     */
    public static signupWithGoogle(
        requestBody?: SignupWithGoogleRequestSchema,
    ): CancelablePromise<SignupWithGoogle200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/signupWithGoogle',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `SignupWithGoogle400Response`,
                401: `SignupWithGoogle401Response`,
            },
        });
    }

    /**
     * refreshToken
     * Refresh token
     * @param requestBody
     * @returns RefreshToken200ResponseSchema RefreshToken200Response
     * @throws ApiError
     */
    public static refreshToken(
        requestBody?: RefreshTokenRequestSchema,
    ): CancelablePromise<RefreshToken200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/refreshToken',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `RefreshToken400Response`,
            },
        });
    }

    /**
     * resendConfirmationEmail
     * resendConfirmationEmail
     * @param requestBody
     * @returns OkResponseSchema ResendConfirmationEmail200Response
     * @throws ApiError
     */
    public static resendConfirmationEmail(
        requestBody?: ResendConfirmationEmailRequestSchema,
    ): CancelablePromise<OkResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/resendConfirmationEmail',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `ResendConfirmationEmail400Response`,
            },
        });
    }

    /**
     * updateUserPassword
     * updateUserPassword
     * @param requestBody
     * @returns OkResponseSchema UpdateUserPassword200Response
     * @throws ApiError
     */
    public static updateUserPassword(
        requestBody?: UpdateUserPasswordRequestSchema,
    ): CancelablePromise<OkResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/updateUserPassword',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `UpdateUserPassword400Response`,
                404: `UpdateUserPassword404Response`,
            },
        });
    }

    /**
     * listUsers
     * list users
     * @param requestBody
     * @returns ListUsers200ResponseSchema ListUsers200Response
     * @throws ApiError
     */
    public static listUsers(
        requestBody?: ListUsersRequestSchema,
    ): CancelablePromise<ListUsers200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/listUsers',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `ListUsers400Response`,
            },
        });
    }

    /**
     * updateUserAsAdmin
     * updateUserAsAdmin
     * @param requestBody
     * @returns UpdateUserAsAdmin200ResponseSchema UpdateUserAsAdmin200Response
     * @throws ApiError
     */
    public static updateUserAsAdmin(
        requestBody?: UpdateUserAsAdminRequestSchema,
    ): CancelablePromise<UpdateUserAsAdmin200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/updateUserAsAdmin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `UpdateUserAsAdmin400Response`,
                404: `UpdateUserAsAdmin404Response`,
            },
        });
    }

}
